/**
 * @file 编辑器常量
 * @author zhanghaohan
 */

export const USER_LEAVE_TIME = 15000;

// 画布尺寸 推给server尺寸16:9(1.777) 视口操作展示19.5:9(2.166)
export const BASE_WIDTH = 378;
export const BASE_HEIGHT = 672;

// fabric textbox 默认行高
export const BASE_LINEHEIGHT = 1.16;

// 背景图生成尺寸
export const ORI_IMG_WIDTH = 1242;
export const ORI_IMG_HEIGHT = 2000;
export const BG_MIN_Y = 508;
export const BG_MAX_Y = 1200;

// 遮罩层宽度
export const MASK_WIDTH = 34;
export const MIN_PART = 5;

// 素材限制
export const PAGE_LIMIT_VIDEO_COUNT = 1;
export const PAGE_LIMIT_PPT_COUNT = 1;
export const CONTENT_LIMIT_VIDEO_COUNT = 2;

// 素材图基础尺寸
export const IMG_BASE_SIZE = {
    x: (60 / BASE_WIDTH).toFixed(3),
    y: (60 / BASE_HEIGHT).toFixed(3),
    w: (180 / BASE_WIDTH).toFixed(3)
};

export const VIDEO_BASE_SIZE = {
    x: (34 / BASE_WIDTH).toFixed(3),
    y: (1 / BASE_HEIGHT).toFixed(3),
    w: (310 / BASE_WIDTH).toFixed(3)
};

// 数字人基础尺寸
export const CHARCTER_BASE_SIZE = {
    x: 0.1,
    y: 0.3,
    w: 0.8
};

// 切镜中的数字人尺寸
export const CHARCTER_VIDEO_SIZE = {
    x: 0.5,
    y: 0.5,
    w: 0.01,
    h: 0.01
};

export const TXT_BASE_SIZE = {
    x: (50 / BASE_WIDTH).toFixed(3),
    y: (50 / BASE_HEIGHT).toFixed(3),
    w: (270 / BASE_WIDTH).toFixed(3),
    h: (65 / BASE_HEIGHT).toFixed(3)
};

export const PPT_BASE_SIZE_MAP = {
    '3p4': {
        x: +(138 / BASE_WIDTH).toFixed(3),
        y: +(50 / BASE_HEIGHT).toFixed(3),
        w: +(102 / BASE_WIDTH).toFixed(3),
        h: +(136 / BASE_HEIGHT).toFixed(3)
    },
    '4p3': {
        x: +(121 / BASE_WIDTH).toFixed(3),
        y: +(50 / BASE_HEIGHT).toFixed(3),
        w: +(136 / BASE_WIDTH).toFixed(3),
        h: +(102 / BASE_HEIGHT).toFixed(3)
    },
    '16p9': {
        x: +(109 / BASE_WIDTH).toFixed(3),
        y: +(50 / BASE_HEIGHT).toFixed(3),
        w: +(160 / BASE_WIDTH).toFixed(3),
        h: +(90 / BASE_HEIGHT).toFixed(3)
    },
    '9p16': {
        x: +(144 / BASE_WIDTH).toFixed(3),
        y: +(50 / BASE_HEIGHT).toFixed(3),
        w: +(90 / BASE_WIDTH).toFixed(3),
        h: +(160 / BASE_HEIGHT).toFixed(3)
    },
    '1p1': {
        x: +(136 / BASE_WIDTH).toFixed(3),
        y: +(50 / BASE_HEIGHT).toFixed(3),
        w: +(106 / BASE_WIDTH).toFixed(3),
        h: +(106 / BASE_HEIGHT).toFixed(3)
    }
};
// ppt 解析
export const PPT_ANALYSIS_TASK = 'huibo_digital_anchor_editor_ppt_analysis_task';
export const PPT_FIRST_COMEIN = 'huibo_digital_anchor_editor_ppt_first_comein';
export const PPT_AI_TASK = 'huibo_digital_anchor_editor_ppt_ai_task';
export const PPT_FIRST_QA_IMAGE = 'huibo_digital_anchor_editor_ppt_first_qa_image';

// 数字人编辑器当前编辑剧本id storage key
export const SCRIPT_ID_IN_EDITOR = 'huibo_digital_anchor_editor_scriptId';
export const SCRIPT_EDITOR_TYPE = 'huibo_digital_anchor_editor_type';
export const AIGC_IMG_GOODS_LIST = 'huibo_digital_anchor_aigc_imgGoodsList';
// 是否第一次创建剧本
export const IS_FIRST_CREATE_SCRIPT = 'huibo_digital_anchor_editor_isFirstCreateScript';
// 数字人互动配置当前人像id
export const FIGURE_ID_FOR_INTERACT = 'huibo_interact_figure_id';

export const FIRST_ENTER_IN_EDITOR = 'huibo_digital_editor_user_first_enter';

export const FIRST_STICKERS_VIDEO = 'huibo_digital_editor_first_video_sticker';

export const FIRST_PPT_USE = 'huibo_digital_editor_first_ppt_use';

export const FIRST_BACKGROUND_VIDEO_OFFLINE = 'huibo_digital_editor_first_background_video_offline';

export const FIRST_CREATE_VIDEO_PAGE = 'huibo_create_video_page';


// 文心优化超时限制 暂定30s
export const ERNIE_TIMEOUT = 40000;

// 文心语气配置项
export const ERNIE_TONE_CONFIG = [
    {
        displayName: '亲和',
        tip: '采用亲和、温暖的语气，适合于比较亲民的产品。',
        value: '亲和'
    }, {
        displayName: '激情',
        tip: '采用充满活力、激情的语气，适合于一些时尚、运动、娱乐等产品。',
        value: '激情'
    }, {
        displayName: '专业',
        tip: '采用严谨、专业的语气，适合于高端、精品产品。',
        value: '专业'
    }, {
        displayName: '幽默',
        tip: '采用幽默、诙谐的语气，适合于娱乐、休闲产品。',
        value: '幽默'
    }, {
        displayName: '感性',
        tip: '采用感性、情感化的语气，适合于一些具有情感属性的产品。',
        value: '感性'
    }, {
        displayName: '激励',
        tip: '采用激励、鼓舞人心的语气，适合于一些涉及到健康、美容等领域的产品。',
        value: '激励'
    }, {
        displayName: '活泼',
        tip: '采用活泼、自信的语气，让产品表达充满生命力。',
        value: '活泼'
    }, {
        displayName: '轻松',
        tip: '采用轻松、愉快的语气，增加观众的认同感和购买欲望。',
        value: '轻松'
    }
];

// 文心字数配置项
export const ERNIE_TEXT_LENGTH_CONFIG = [
    {
        displayName: '简洁',
        tip: '快速传递核心观点，该段讲解时长约10秒',
        value: '60字以内'
    }, {
        displayName: '概括',
        tip: '突出关键信息，该段讲解时长约20秒',
        value: '60字到120字'
    }, {
        displayName: '适中',
        tip: '融合丰富细节，该段讲解时长约30秒',
        value: '120字到180字'
    }, {
        displayName: '详实',
        tip: '提供深入分析，该段讲解时长约60秒',
        value: '180字到240字'
    }, {
        displayName: '充分',
        tip: '完整展现主题，该段讲解时长60秒以上',
        value: '240字到400字'
    }
];

export const ERNIE_TEXT_CONFIG = [
    {
        label: '扩写文案',
        title: '提供深入分析，该段讲解时长约60秒',
        value: '240字到400字',
        key: '扩写文案'
    },
    {
        label: '精简文案',
        title: '快速传递核心观点，该段讲解时长约10秒',
        value: '60字以内',
        key: '60字以内'
    },
    {
        label: '调整语气',
        key: '调整语气',
        title: '调整语气',
        value: '调整语气',
        children: [
            {
                label: '亲切友好',
                title: '采用亲和、温暖的语气，适合于比较亲民的产品。',
                value: '亲和',
                key: '亲和'
            },
            {
                label: '轻松',
                title: '采用轻松、愉快的语气，增加观众的认同感和购买欲望。',
                value: '轻松',
                key: '轻松'
            },
            {
                label: '感性',
                title: '采用感性、情感化的语气，适合于一些具有情感属性的产品。',
                value: '感性',
                key: '感性'
            }
        ]
    }
];

// 文心默认语气
export const DEFAULT_ERNIE_TONE_VALUE = '日常';

// 文心默认字数
export const DEFAULT_ERNIE_TEXT_LENGTH = '120字到180字';

// 语音播报 停顿预设值
export const TTS_SILENCE_MAP = [
    {
        displayName: '极弱（0.25s）',
        displayValue: '0.25s',
        value: '250ms'
    }, {
        displayName: '弱（0.5s）',
        displayValue: '0.5s',
        value: '500ms'
    }, {
        displayName: '中等（0.75s）',
        displayValue: '0.75s',
        value: '750ms'
    }, {
        displayName: '强（1s）',
        displayValue: '1s',
        value: '1s'
    }, {
        displayName: '极强（1.25s）',
        displayValue: '1.25s',
        value: '1250ms'
    }
];

export const TTS_PY_TONE_MAP = [
    {
        displayName: '一声',
        value: '1'
    }, {
        displayName: '二声',
        value: '2'
    }, {
        displayName: '三声',
        value: '3'
    }, {
        displayName: '四声',
        value: '4'
    }, {
        displayName: '轻声',
        value: '5'
    }
];

export const DEFAULT_DRAFT_RAW = {
    blocks: [
        {
            text: '',
            type: 'unstyled',
            entityRanges: []
        }
    ],
    entityMap: {}
};

export const GENDER_MAP = {
    0: '全部',
    1: '男声',
    2: '女声'
};

export const DEFAULT_CHARACTER_CONFIG_LIST = [
    {
        group: 'character',
        key: 4,
        title: '基础配置',
        event: 'base',
        text: ''
    }
];

export const DEFAULT_INTERACT_CONFIG_LIST = [
    {
        group: 'intereact',
        key: 0,
        title: '欢迎语',
        event: 'enter',
        text: '欢迎欢迎，点击直播间左上角关注，关注主播之后更方便找到直播间哟'
    }, {
        group: 'intereact',
        key: 1,
        title: '关注感谢',
        event: 'follow',
        text: '感谢关注，喜欢就赶紧下单哦，数量有限，先到先得'
    }, {
        group: 'intereact',
        key: 2,
        title: '点赞感谢',
        event: 'like',
        text: '感谢宝宝们的点赞，点击右下角小红袋可查看商品详情哦'
    }, {
        group: 'intereact',
        key: 3,
        title: '分享感谢',
        event: 'share',
        text: '感谢宝宝们分享直播间，感谢您将我们的好产品传播给更多人！'
    }
];

export const presetColors = [
    'transparent', '#73BFF9', '#98FAEA', '#A4F76A', '#FDF171', '#F19B91',
    '#F19AC8', '#479FF8', '#6BE3CF', '#81D653', '#F9DB57', '#ED6E57',
    '#EB539F', '#3274B5', '#4CA98F', '#54AE32', '#F2B13D', '#DA3B26',
    '#C23175', '#1E4C7C', '#2D6A65', '#306F1D', '#F38435', '#A62B17',
    '#8A2052', '#FFFFFF', '#D5D5D5', '#929292', '#5E5E5E', '#000000'
];

// 使用过的纯色背景颜色
export const USED_BACKGROUND_COLORS = 'huibo_digital_background_colors_used';

export const DEFAULT_WHITE_BACKGROUND = {
    id: 1,
    url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/073a6f28e07b8461d5bb27577725efc2.png@c_1,x_0,y_0,w_378,h_672',
    name: '默认白色背景'
};

export const presetSolidColor = [
    {
        color: '#EA5246',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/cce99356ddff3f1b2f33e7dc2c859bcc.png'
    },
    {
        color: '#D3594A',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/cd2778ab0fceb38e73093e0314966aa9.png'
    },
    {
        color: '#CDA2A1',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/25b63cadfb3c09fb3d4846c80e29157c.png'
    },
    {
        color: '#ECB9A6',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/e11fb05561a956d2170ff4eb6b8f88a0.png'
    },
    {
        color: '#EDBFBF',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/5d58e92cc5389dbf9ad4646e0eeef9ee.png'
    },
    {
        color: '#F5E7E7',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/44a5c16d98fe3ed2b11e87130ec47ab8.png'
    },
    {
        color: '#FBE6E9',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/f98651de4868549be1f4403abd90626c.png'
    },
    {
        color: '#836355',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/d28ca517c1f7fdab3e177f7725f33800.png'
    },
    {
        color: '#E3CBB7',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/60d6313563cfca2174318218c486381f.png'
    },
    {
        color: '#E3D4CB',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/e7c64c9e96a88f5f3d854463dd4d4cd0.png'
    },
    {
        color: '#EDE4DB',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/3786f5393206123132f7a509e067422e.png'
    },
    {
        color: '#FEF2CE',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/eff56539e6e45562491c57018a5a6654.png'
    },
    {
        color: '#3172D7',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/275a63dc28fb0bf7ffa835105429c901.png'
    },
    {
        color: '#57A7D0',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/81c987c6d5deccfef79ef8e88fed30f1.png'
    },
    {
        color: '#79A0EB',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/5ab3c005a30f19eb8887bd9dc0ad8162.png'
    },
    {
        color: '#AEC9F3',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/32840ca4265ff21a5061128628abb5f6.png'
    },
    {
        color: '#BEE4FA',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/d9ff1d9d98ab5bb9e0c19a8c489a1209.png'
    },
    {
        color: '#C9D8F1',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/c4cb625383f57b25ab62801d2aa21a41.png'
    },
    {
        color: '#E3ECF7',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/e72aee748c51bb86f54b4e8baed74c14.png'
    },
    {
        color: '#315B2B',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/7f30155f2766f25b75ce9910c87b3c7b.png'
    },
    {
        color: '#4B8368',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/8018fe44243eab4e2b6697aa556380c5.png'
    },
    {
        color: '#97CECD',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/429851e61694b93134d8930450beb2d5.png'
    },
    {
        color: '#8B8B92',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/7969bbe14081b16815a59dd0570c5a87.png'
    },
    {
        color: '#D8D4D3',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/986919337f36693e326595ecb4f87707.png'
    }
];

export const presetGradientColor = [
    {
        color: 'linear-gradient(180deg, #FF9A9E 0%, #FADDC4 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/4d4387b8b708cf19f49c9431ae2e4007.png'
    },
    {
        color: 'linear-gradient(180deg, #FFECD2 0%, #FCB69F 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/66faf2d7a6c318f7068a876a70a90e17.png'
    },
    {
        color: 'linear-gradient(180deg, #F0E7C0 0%, #F18F89 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/5ae2202851686e246f6dacbf5681bd71.png'
    },
    {
        color: 'linear-gradient(0deg, #FFF6E8 0%, #FEDFAC 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/8fcb20dcf1ad31c05cbd7f1cfd8b5a49.png'
    },
    {
        color: 'linear-gradient(179deg, #D1C2FF 0%, #FFB9B6 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/f5ed13bdfc024250afc6d38d7c3ddbd1.png'
    },
    {
        color: 'linear-gradient(180deg, #FBC2EB 0%, #A6C1EE 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/58557caa5bd182a55cdc2911499745be.png'
    },
    {
        color: 'linear-gradient(180deg, #E0C3FC 0%, #8EC5FC 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/c99235ddc1cece58b22020949ee36dbe.png'
    },
    {
        color: 'linear-gradient(180deg, #FFEFFB 0%, #A6C1EE 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/74463f0a06ec24b0e5cc6a7883fb6d46.png'
    },
    {
        color: 'linear-gradient(180deg, #A1C4FD 0%, #C2E8FB 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/24fa554db3b1b448ebdc2ec359938f71.png'
    },
    {
        color: 'linear-gradient(180deg, #ACCBEE 0%, #E9EFFD 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/19fa570fda7c3edbdc55196d4abf43b6.png'
    },
    {
        color: 'linear-gradient(180deg, #93A6C7 0%, #E4EFE9 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/e6a574eb34aaf3b2f71f034547175a40.png'
    },
    {
        color: 'linear-gradient(180deg, #AAE0F9 0%, #FCF1EB 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/b5ee754ab853dfbf04d8cce271ccab2a.png'
    },
    {
        color: 'linear-gradient(180deg, #A9F1DF 0%, #FFBBBB 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/9582e8dd0f7c08fca57bbf8c729590e5.png'
    },
    {
        color: 'linear-gradient(180deg, #ECFFC6 0%, #E798A9 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/e0241262ae4342b190337fb7d2e49aad.png'
    },
    {
        color: 'linear-gradient(180deg, #FDDD92 0%, #B6FDFF 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/d777c0f6bc9e9412533cc15da4c18d69.png'
    },
    {
        color: 'linear-gradient(180deg, #80CEFF 0%, #E9F7D1 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/935878a69413eeabe6b3f601e61ac03d.png'
    },
    {
        color: 'linear-gradient(180deg, #B7EEE1 0%, #8FD8F9 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/ab5762fe00999dac9918ff96bc2c1147.png'
    },
    {
        color: 'linear-gradient(180deg, #D8B5FF 0%, #41D4BE 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/b9caf8002bab2a80c909934544e281be.png'
    },
    {
        color: 'linear-gradient(180deg, #ECAFEF 0%, #C8F6FE 100%)',
        url: 'https://live-cecom-image.cdn.bcebos.com/upload_image/c20ef497c50244d10569dd9e8b0849ce.png'
    }
];

export const DEFAULT_MUSIC_BG = {
    url: '',
    name: '',
    id: '',
    duration: '', // 音频时长
    volume: 18,
    is_circle: 0,
    range: 'cur_page'
};

export const defaultStyle = {
    color: 'rgba(51, 51, 51, 1)',
    textStrokeWidth: 1,
    WebkitTextStrokeWidth: 1,
    textStrokeColor: 'transparent',
    WebkitTextStrokeColor: 'transparent',
    textShadow: 'transparent',
    textShadowX: '0',
    textShadowY: '0',
    textShadowValue: '0'
};

export const presetTextStyle = [
    {
        color: '#FFFFFF',
        textStrokeColor: '#DF7853',
        textStrokeWidth: '3',
        textShadow: '#AF422A',
        textShadowX: '3',
        textShadowY: '3',
        textShadowValue: '0'
    },
    {
        color: '#DA535A',
        textStrokeColor: '#FFFFFF',
        textStrokeWidth: '4'
    },
    {
        color: '#D882A2',
        textStrokeColor: '#FFFFFF',
        textStrokeWidth: '4'
    },
    {
        color: '#EDB958',
        textStrokeColor: '#000000',
        textStrokeWidth: '5'
    },
    {
        color: '#000000',
        textShadow: '#ECB858',
        textStrokeWidth: '0',
        textShadowX: '2',
        textShadowY: '2',
        textShadowValue: '0'
    },
    {
        color: '#F6E083',
        textStrokeColor: '#553516',
        textStrokeWidth: '4',
        textShadow: '#E4BD59',
        textShadowX: '3',
        textShadowY: '3',
        textShadowValue: '3'
    },
    {
        color: '#F9E783',
        textStrokeColor: '#3B47EB',
        textStrokeWidth: '4',
        textShadow: '#8C47B8',
        textShadowX: '3',
        textShadowY: '2',
        textShadowValue: '1'
    },
    {
        color: '#68A3B0',
        textStrokeWidth: '4',
        textStrokeColor: '#FFFFFF'
    },
    {
        color: '#FFFFFF',
        textStrokeWidth: '4',
        textStrokeColor: '#89BC67'
    },
    {
        color: '#000000',
        backgroundColor: '#FFFFFF'
    },
    {
        color: '#000000',
        backgroundColor: '#F7DE66'
    }
];

export const BACKGROUND_TEMPLATE_DATA = 'huibo_background_template_edit_data';

// 颜色选择器
export const COLOR_LIST = [
    '#EC1313',
    '#F3A62C',
    '#FFEA7D',
    '#20995F',
    '#6DAEF8',
    '#2B45EA',
    '#CE78F7',
    '#F088C4',
    '#C0AA8F',
    '#FFFFFF',
    '#C1CBDA',
    '#2B2829'
];
export const COLOR_MAP = {
    ['']: 0,
    ['#EC1313']: 1,
    ['#F3A62C']: 2,
    ['#FFEA7D']: 3,
    ['#20995F']: 4,
    ['#6DAEF8']: 5,
    ['#2B45EA']: 6,
    ['#CE78F7']: 7,
    ['#F088C4']: 8,
    ['#C0AA8F']: 9,
    ['#FFFFFF']: 10,
    ['#C1CBDA']: 11,
    ['#2B2829']: 12
};
export const COLOR_DESC_MAP = {
    ['']: '全部',
    ['#EC1313']: '红色',
    ['#F3A62C']: '橙色',
    ['#FFEA7D']: '黄色',
    ['#20995F']: '绿色',
    ['#6DAEF8']: '浅蓝',
    ['#2B45EA']: '深蓝',
    ['#CE78F7']: '紫色',
    ['#F088C4']: '粉色',
    ['#C0AA8F']: '咖色',
    ['#FFFFFF']: '白色',
    ['#C1CBDA']: '灰色',
    ['#2B2829']: '黑色'
};
export const RISK_TYPE_MAP = {
    'i': 'image',
    'p': 'ppt',
    't': 'txt',
    'a': 'audio',
    'v': 'video'
};

export const FIGURE_TYPE_MAP = {
    pub: 2,
    personal: 1
};

export const CREATE_COLOR_OPTIONS = {
    ALL: '全部',
    RED: '红色',
    KHAKI: '橙色',
    YELLOW: '黄色',
    GREEN: '绿色',
    LIGHT_BLUE: '浅蓝',
    DEEP_BLUE: '深蓝',
    PURPLE: '紫色',
    PINK: '粉色',
    BROWN: '咖色',
    WHITE: '白色',
    GREY: '灰色',
    BLACK: '黑色'
};

// 标注图
export const MODULE_TAGGED_CHARACTER = 'https://huibo-data.cdn.bcebos.com/upload/442c10cefb5f6a483b3eb849c19f8b5a.png';

export const MODULE_TAGGED_PIC_MAP = {
    [CREATE_COLOR_OPTIONS.WHITE]: 'https://huibo-data.cdn.bcebos.com/upload/7bd62fe28de010b87bedc47bcbdb2800.png',
    [CREATE_COLOR_OPTIONS.BLACK]: 'https://huibo-data.cdn.bcebos.com/upload/b57d28747455ec3e466dfbb3e70263d3.png',
    [CREATE_COLOR_OPTIONS.YELLOW]: 'https://huibo-data.cdn.bcebos.com/upload/56799387629f52358211cf960647691a.png',
    [CREATE_COLOR_OPTIONS.GREY]: 'https://huibo-data.cdn.bcebos.com/upload/9e4a7c85e20e7c78885f547931ba140c.png',
    [CREATE_COLOR_OPTIONS.PURPLE]: 'https://huibo-data.cdn.bcebos.com/upload/0afbc1bba886ca11d13887abdc0aba0e.png',
    [CREATE_COLOR_OPTIONS.PINK]: 'https://huibo-data.cdn.bcebos.com/upload/b48970ba2e9c674509c333b900ceba05.png',
    [CREATE_COLOR_OPTIONS.DEEP_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/2c19dcd59631ab6eeef99dbd4c66ac16.png',
    [CREATE_COLOR_OPTIONS.RED]: 'https://huibo-data.cdn.bcebos.com/upload/91b89a6c2c9a027d531d68746ba3a209.png',
    [CREATE_COLOR_OPTIONS.BROWN]: 'https://huibo-data.cdn.bcebos.com/upload/fbf8c3b31177b0e5c0c56924cac9a4d2.png',
    [CREATE_COLOR_OPTIONS.KHAKI]: 'https://huibo-data.cdn.bcebos.com/upload/dc7438981c1aebd6b3a52a8364fe44a2.png',
    [CREATE_COLOR_OPTIONS.GREEN]: 'https://huibo-data.cdn.bcebos.com/upload/523bdd979ee8bc111f0b66565597ca7a.png',
    [CREATE_COLOR_OPTIONS.LIGHT_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/bca32ada824b61bbbf9ef10b221cf769.png'
};

export const MODULE_TAGGED_VIDEO_3_4_MAP = {
    [CREATE_COLOR_OPTIONS.WHITE]: 'https://huibo-data.cdn.bcebos.com/upload/4f20039d66fa4623b0d4bf4158efa493.png',
    [CREATE_COLOR_OPTIONS.BLACK]: 'https://huibo-data.cdn.bcebos.com/upload/d0c7182b50a24516ae3b54c13313d6c7.png',
    [CREATE_COLOR_OPTIONS.YELLOW]: 'https://huibo-data.cdn.bcebos.com/upload/3900bd4224cd4a8b58a857a5f9997c1e.png',
    [CREATE_COLOR_OPTIONS.GREY]: 'https://huibo-data.cdn.bcebos.com/upload/ff7dae0715f0dad3f4d5406a57585d71.png',
    [CREATE_COLOR_OPTIONS.PURPLE]: 'https://huibo-data.cdn.bcebos.com/upload/081cfc7f67f4ef7906ae077afd290a42.png',
    [CREATE_COLOR_OPTIONS.PINK]: 'https://huibo-data.cdn.bcebos.com/upload/6790fd552559bfd8c0ba07ef20e1877d.png',
    [CREATE_COLOR_OPTIONS.DEEP_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/d8854e8df6136a824feb81c5f92ba938.png',
    [CREATE_COLOR_OPTIONS.RED]: 'https://huibo-data.cdn.bcebos.com/upload/bd364bb45ae80788dec35b3753d41278.png',
    [CREATE_COLOR_OPTIONS.BROWN]: 'https://huibo-data.cdn.bcebos.com/upload/10f5c8ad67975e725617079017686518.png',
    [CREATE_COLOR_OPTIONS.KHAKI]: 'https://huibo-data.cdn.bcebos.com/upload/3c392f51fca78eef5cdc8422c0e4cf9a.png',
    [CREATE_COLOR_OPTIONS.GREEN]: 'https://huibo-data.cdn.bcebos.com/upload/a0b4a135cfd7949bccf539afb9c5c2b5.png',
    [CREATE_COLOR_OPTIONS.LIGHT_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/642c65ee56d1453320c2bef26fcb1206.png'
};

export const MODULE_TAGGED_VIDEO_4_3_MAP = {
    [CREATE_COLOR_OPTIONS.WHITE]: 'https://huibo-data.cdn.bcebos.com/upload/aaec0624df434bec1a72ac7c1ef84ed2.png',
    [CREATE_COLOR_OPTIONS.BLACK]: 'https://huibo-data.cdn.bcebos.com/upload/f868dcd4ddcff921a7b4610d0b4fe577.png',
    [CREATE_COLOR_OPTIONS.YELLOW]: 'https://huibo-data.cdn.bcebos.com/upload/2da9102e3c386502fab8f351f906abea.png',
    [CREATE_COLOR_OPTIONS.GREY]: 'https://huibo-data.cdn.bcebos.com/upload/9489155740ac184126d4e98518b7e959.png',
    [CREATE_COLOR_OPTIONS.PURPLE]: 'https://huibo-data.cdn.bcebos.com/upload/30e4318884870cc98a80e6a2068a57cd.png',
    [CREATE_COLOR_OPTIONS.PINK]: 'https://huibo-data.cdn.bcebos.com/upload/38c1142efb1772dbf28a18352b59ec80.png',
    [CREATE_COLOR_OPTIONS.DEEP_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/6440c167ebb2df1d5b227fe49c1300d6.png',
    [CREATE_COLOR_OPTIONS.RED]: 'https://huibo-data.cdn.bcebos.com/upload/aa7287319cf2e0cd74ac4deb4ddbec28.png',
    [CREATE_COLOR_OPTIONS.BROWN]: 'https://huibo-data.cdn.bcebos.com/upload/91c793ade099c2b8d8209eedc2aa0a68.png',
    [CREATE_COLOR_OPTIONS.KHAKI]: 'https://huibo-data.cdn.bcebos.com/upload/42e078ef65e50828bb024d967d6ccc92.png',
    [CREATE_COLOR_OPTIONS.GREEN]: 'https://huibo-data.cdn.bcebos.com/upload/b89281648a7dbac645821d73d80ea025.png',
    [CREATE_COLOR_OPTIONS.LIGHT_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/ac28d28cc9f223c3bf335be24f53d936.png'
};

export const MODULE_TAGGED_VIDEO_9_16_MAP = {
    [CREATE_COLOR_OPTIONS.WHITE]: 'https://huibo-data.cdn.bcebos.com/upload/dcf5bce5b55203c48587f20cc38caddb.png',
    [CREATE_COLOR_OPTIONS.BLACK]: 'https://huibo-data.cdn.bcebos.com/upload/8e400ace5c2faa01b0ba2dd14cb3bf4c.png',
    [CREATE_COLOR_OPTIONS.YELLOW]: 'https://huibo-data.cdn.bcebos.com/upload/45fd891686ff56313bd9c175e9d5d00d.png',
    [CREATE_COLOR_OPTIONS.GREY]: 'https://huibo-data.cdn.bcebos.com/upload/f2daac5a291372940eaef152d947e1ab.png',
    [CREATE_COLOR_OPTIONS.PURPLE]: 'https://huibo-data.cdn.bcebos.com/upload/01eddf984e250adb85e9a9f887846632.png',
    [CREATE_COLOR_OPTIONS.PINK]: 'https://huibo-data.cdn.bcebos.com/upload/ee0010409c29a6d6cfc80df1d327d99b.png',
    [CREATE_COLOR_OPTIONS.DEEP_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/3ecc203fb26cbf23352859809984d277.png',
    [CREATE_COLOR_OPTIONS.RED]: 'https://huibo-data.cdn.bcebos.com/upload/7b70896b70f6447375d2d13d39846e5a.png',
    [CREATE_COLOR_OPTIONS.BROWN]: 'https://huibo-data.cdn.bcebos.com/upload/4bb23b940757bdab20f6045cd97e857e.png',
    [CREATE_COLOR_OPTIONS.KHAKI]: 'https://huibo-data.cdn.bcebos.com/upload/fe5a4934884ccb881591b4280f35aabc.png',
    [CREATE_COLOR_OPTIONS.GREEN]: 'https://huibo-data.cdn.bcebos.com/upload/b561b2cba606a89add72c7b9cd384ee1.png',
    [CREATE_COLOR_OPTIONS.LIGHT_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/409248ba767c2b6342a19f31bd353336.png'
};

export const MODULE_TAGGED_VIDEO_16_9_MAP = {
    [CREATE_COLOR_OPTIONS.WHITE]: 'https://huibo-data.cdn.bcebos.com/upload/1e1e9f2d8b57648d29c27cab71944fdb.png',
    [CREATE_COLOR_OPTIONS.BLACK]: 'https://huibo-data.cdn.bcebos.com/upload/2a01dc0aa4eae43ec8b97f1a6fb960e2.png',
    [CREATE_COLOR_OPTIONS.YELLOW]: 'https://huibo-data.cdn.bcebos.com/upload/73b0f5ed6e6b475146024425162819f2.png',
    [CREATE_COLOR_OPTIONS.GREY]: 'https://huibo-data.cdn.bcebos.com/upload/bf391ddc135a1b1e0aee84b6e108d8c0.png',
    [CREATE_COLOR_OPTIONS.PURPLE]: 'https://huibo-data.cdn.bcebos.com/upload/4e52034f629cf9d1130dc07f968aa2b5.png',
    [CREATE_COLOR_OPTIONS.PINK]: 'https://huibo-data.cdn.bcebos.com/upload/9327021918032388faf7b00cedfcdfa1.png',
    [CREATE_COLOR_OPTIONS.DEEP_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/f83d15d87359439dfd107974a8002d1f.png',
    [CREATE_COLOR_OPTIONS.RED]: 'https://huibo-data.cdn.bcebos.com/upload/f466555eb0b7c4ce7d14a21594b2bd29.png',
    [CREATE_COLOR_OPTIONS.BROWN]: 'https://huibo-data.cdn.bcebos.com/upload/30ec1622d3f79f21d300ab9fe49a811b.png',
    [CREATE_COLOR_OPTIONS.KHAKI]: 'https://huibo-data.cdn.bcebos.com/upload/3482c314310ed72536303a9edda53640.png',
    [CREATE_COLOR_OPTIONS.GREEN]: 'https://huibo-data.cdn.bcebos.com/upload/d194184bf1a456eefe69a542c10f835f.png',
    [CREATE_COLOR_OPTIONS.LIGHT_BLUE]: 'https://huibo-data.cdn.bcebos.com/upload/03532acea1d3bde0f2ecd520cce8397e.png'
};

export const FIRST_USE_VOICE_MODAL = 'huibo_digital_editor_first_use_voice_modal';

export const HEALTH_CATEGORY_LIST_DEFAULT = {
    name: '全部',
    category: 0
};
